import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  FileButton,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { IconArrowBack, IconArrowUp, IconCheck } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { api } from "../../../library/axios";
import { MessageResponse } from "../../../model/MessageResponse";
import { CongVanModel } from "../../../model/ModelCongVan";
const CongVanEdit = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result?.toString().split(",")[1] || "";
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  const form = useForm<CongVanModel>({
    mode: "uncontrolled",
  });

  useEffect(() => {
    const fetchCongVanDetail = async () => {
      setLoadingData(false);

      if (!id) {
        return;
      }

      try {
        const response = await api.get<MessageResponse<CongVanModel>>(
          `/TblCongVan/get-update?Id=${id}`
        );

        if (response && response.data) {
          form.setValues({
            ...response.data.data,
          });
        } else {
          NotificationExtension.Fails("Không thể tải dữ liệu công văn!");
        }
      } catch (error) {
        console.error("Error fetching congvan detail:", error);
        NotificationExtension.Fails("Có lỗi xảy ra khi tải dữ liệu!");
      } finally {
        setLoadingData(false);
      }
    };

    fetchCongVanDetail();
  }, [id]);

  // const handleInputChange = (field: keyof any, value: any) => {
  //   form.setValues((prev: any) => {
  //     let newData = { ...prev, [field]: value };

  //     if (field === "loaiCongVan") {
  //       if (value === "đến") {
  //         newData.soDi = "";
  //         newData.ngayPhatHanh = "";
  //       } else if (value === "đi") {
  //         newData.soDen = "";
  //         newData.ngayDen = "";
  //       }
  //     }
  //     if (field === "ngayCoHieuLuc") {
  //       const ngayCoHieuLucFormatted = formatDateNotTimeZone(value);
  //       newData.ngayCoHieuLuc = ngayCoHieuLucFormatted;

  //       const nextMonth = dayjs(ngayCoHieuLucFormatted)
  //         .add(1, "month")
  //         .endOf("day")
  //         .format();
  //       newData.ngayHetHieuLuc = nextMonth;
  //     }
  //     return newData;
  //   });
  // };

  const validateForm = (): boolean => {
    // if (!congvandata.soVanBan.trim()) {
    //   NotificationExtension.Fails("Số văn bản là bắt buộc!");
    //   return false;
    // }

    // if (!congvandata.loaiVanBan) {
    //   NotificationExtension.Fails("Loại văn bản là bắt buộc!");
    //   return false;
    // }

    // if (!congvandata.trichYeuNoiDung.trim()) {
    //   NotificationExtension.Fails("Trích yếu nội dung là bắt buộc!");
    //   return false;
    // }

    return true;
  };

  // Hàm cập nhật công văn
  const handleUpdate = async () => {
    if (!validateForm()) return;
    setLoading(true);

    try {
      const data = form.getValues();
      const formData = new FormData();

      // Thêm các trường khác vào formData
      Object.entries(data).forEach(([key, value]) => {
        // Không thêm trường tepDinhKem ở đây, sẽ thêm ở dưới
        if (key !== "tepDinhKem") {
          formData.append(key, value ?? "");
        }
      });

      // Thêm file nếu có
      if (file) {
        formData.append("TepDinhKem", file); // Tên phải đúng với API
      }
      const url = !id ? `/TblCongVan/create` : `/TblCongVan/update`;

      // Gửi request với content-type multipart/form-data
      const response = await api.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response) {
        NotificationExtension.Success("Cập nhật công văn thành công!");
        setTimeout(() => {
          window.history.back();
        }, 500);
      } else {
        NotificationExtension.Success("Cập nhật công văn thành công!");
        setTimeout(() => {
          window.history.back();
        }, 500);
      }
    } catch (error) {
      NotificationExtension.Fails("Có lỗi xảy ra khi cập nhật công văn!");
    } finally {
      setLoading(false);
    }
  };
  console.log("form values:", form.getValues());
  return (
    <Box pos="relative">
      <LoadingOverlay visible={loadingData} />

      <Group justify="space-between" align="center" mb="xs">
        <_breadcrumb />
        <Group gap={10}>
          <Button
            type="button"
            color="red"
            variant="outline"
            leftSection={<IconArrowBack />}
            onClick={() => window.history.back()}
            disabled={loading}
          >
            Quay lại
          </Button>
          <Button
            color="teal"
            variant="outline"
            leftSection={<IconCheck size={18} />}
            onClick={handleUpdate}
            loading={loading}
          >
            Cập nhật công văn
          </Button>
        </Group>
      </Group>

      <Fieldset legend="Thông tin công văn">
        <Grid>
          <Grid.Col span={4}>
            <Select
              label="Loại công văn"
              data={["đến", "đi"]}
              value={form.getValues().loaiCongVan}
              onChange={(value) =>
                form.setFieldValue("loaiCongVan", value ?? "")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            {form.getValues().loaiCongVan === "đến" ? (
              <TextInput
                label="Số đến"
                key={form.key("soDen")}
                {...form.getInputProps("soDen")}
              />
            ) : (
              <TextInput
                label="Số đi"
                key={form.key("soDi")}
                {...form.getInputProps("soDi")}
              />
            )}
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              label="Loại văn bản"
              data={[
                "Nghị quyết",
                "Thông báo",
                "Quyết định",
                "Hợp đồng",
                "Công văn",
                "Thông tư",
                "Thư",
                "Nghị định",
                "Tờ trình",
              ]}
              required
              value={form.getValues().loaiVanBan}
              onChange={(value) =>
                form.setFieldValue("loaiVanBan", value || "")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Số văn bản"
              required
              key={form.key("soVanBan")}
              {...form.getInputProps("soVanBan")}
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <TextInput
              label="Nơi gửi"
              key={form.key("noiGui")}
              {...form.getInputProps("noiGui")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Người ký"
              key={form.key("nguoiKy")}
              {...form.getInputProps("nguoiKy")}
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <DateTimePicker
              label="Ngày đến"
              disabled={form.getValues().loaiCongVan !== "đến"}
              value={
                form.getValues().ngayDen
                  ? new Date(form.getValues().ngayDen)
                  : null
              }
              onChange={(date) =>
                form.setFieldValue(
                  "ngayDen",
                  formatDateNotTimeZone(date || new Date())
                )
              }
            />
          </Grid.Col>

          {form.getValues().loaiCongVan === "đi" && (
            <Grid.Col span={4}>
              <DateTimePicker
                label="Ngày phát hành"
                value={
                  form.getValues().ngayPhatHanh
                    ? new Date(form.getValues().ngayPhatHanh)
                    : null
                }
                onChange={(date) =>
                  form.setFieldValue(
                    "ngayPhatHanh",
                    formatDateNotTimeZone(date || new Date())
                  )
                }
              />
            </Grid.Col>
          )}
          <Grid.Col span={4}>
            <DateTimePicker
              label="Ngày có hiệu lực"
              value={
                form.getValues().ngayCoHieuLuc
                  ? new Date(form.getValues().ngayCoHieuLuc)
                  : new Date()
              }
              onChange={(date) =>
                form.setFieldValue(
                  "ngayCoHieuLuc",
                  formatDateNotTimeZone(date || new Date())
                )
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <DateTimePicker
              label="Ngày hết hiệu lực"
              value={
                form.getValues().ngayHetHieuLuc
                  ? new Date(form.getValues().ngayHetHieuLuc)
                  : new Date()
              }
              onChange={(date) =>
                form.setFieldValue(
                  "ngayHetHieuLuc",
                  formatDateNotTimeZone(date || new Date())
                )
              }
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <Select
              label="Mức độ khẩn cấp"
              data={["Bình thường", "Khẩn", "Hỏa tốc"]}
              value={form.getValues().mucDoKhanCap}
              onChange={(value) =>
                form.setFieldValue("mucDoKhanCap", value || "Bình thường")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              label="Mức độ bảo mật"
              data={["Thường", "Mật", "Tuyệt mật"]}
              value={form.getValues().mucDoBaoMat}
              onChange={(value) =>
                form.setFieldValue("mucDoBaoMat", value || "Thường")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              label="Dạng văn bản"
              data={["Bản giấy", "Điện tử"]}
              value={form.getValues().dangVanBan}
              onChange={(value) =>
                form.setFieldValue("dangVanBan", value || "Bản giấy")
              }
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Số trang"
              type="number"
              key={form.key("soTrang")}
              {...form.getInputProps("soTrang")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Đơn vị"
              key={form.key("donVi")}
              {...form.getInputProps("donVi")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Vị trí lưu trữ"
              key={form.key("viTriLuuTru")}
              {...form.getInputProps("viTriLuuTru")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Số bản phát hành"
              type="number"
              key={form.key("soBanPhatHanh")}
              {...form.getInputProps("soBanPhatHanh")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label="Nơi nhận"
              key={form.key("noiNhan")}
              {...form.getInputProps("noiNhan")}
            />
          </Grid.Col>

          <Grid.Col
            span={4}
            style={{
              display: "flex",
              paddingTop: "24px",
              alignItems: "center",
            }}
          >
            <FileButton
              onChange={(selectedFile) => {
                if (!selectedFile) return;
                setFile(selectedFile);
              }}
              accept=".docx"
            >
              {(props) => (
                <Button
                  {...props}
                  size="xs"
                  variant="light"
                  fullWidth
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: 38, // cho đồng bộ chiều cao với input
                  }}
                >
                  <IconArrowUp size={16} />
                  <span style={{ marginLeft: 8 }}>
                    {file?.name || "Chọn file đính kèm"}
                  </span>
                </Button>
              )}
            </FileButton>
          </Grid.Col>
          <Grid.Col span={12}>
            <Textarea
              label="Trích yếu nội dung"
              minRows={6}
              rows={6}
              withAsterisk
              // value={form.getValues().trichYeuNoiDung}
              // onChange={(e) =>
              //   form.setFieldValue("trichYeuNoiDung", e.currentTarget.value)
              // }
              key={form.key("trichYeuNoiDung")}
              {...form.getInputProps("trichYeuNoiDung")}
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <TextInput
              label="Người xử lý"
              key={form.key("nguoiXuLy")}
              {...form.getInputProps("nguoiXuLy")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              label="Tình trạng xử lý"
              data={["Chờ xử lý", "Đang xử lý", "Đã xử lý"]}
              key={form.key("tinhTrangXuLy")}
              {...form.getInputProps("tinhTrangXuLy")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <DateTimePicker
              label="Hạn xử lý"
              value={
                form.getValues().hanXuLy
                  ? new Date(form.getValues().hanXuLy)
                  : new Date()
              }
              onChange={(date) =>
                form.setFieldValue(
                  "hanXuLy",
                  date?.toISOString() || new Date().toISOString()
                )
              }
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Checkbox
              label="Không cho phép nhân viên tra cứu"
              checked={!form.getValues().choPhepTraCuu}
              onChange={(e) =>
                form.setFieldValue("choPhepTraCuu", !e.currentTarget.checked)
              }
            />
          </Grid.Col>
        </Grid>
      </Fieldset>
    </Box>
  );
};

export default CongVanEdit;
